import styled from 'styled-components';

export const TableContainer = styled.div`
  position: relative;

  &:hover .remove {
    visibility: visible;
  }

  .remove {
    position: absolute;
    top: 20px;
    right: 4px;
    transform: translateY(-50%);
    visibility: hidden;
    background-color: rgb(240 240 240);

    &:hover {
      background-color: rgb(235 235 235);
    }
  }
`;
